"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.putLogisticsOptionAccessibility = exports.deleteLogisticsOptionPermission = exports.postLogisticsOptionPermission = exports.postLogisticsOption = exports.putLogisticsOption = exports.getLogisticsOption = exports.getLogisticsOptions = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var logisticsOptionsAuthorizedPath = root_1.ecommerceAuthorized + '/logisticsoptions/';
var logisticsOptionsPublicPath = root_1.ecommercePublic + '/logisticsoptions/';

var getLogisticsOptions = function getLogisticsOptions(authentication, queryParameters) {
  return common_1.get(authentication, logisticsOptionsAuthorizedPath, queryParameters);
};

exports.getLogisticsOptions = getLogisticsOptions;

var getLogisticsOption = function getLogisticsOption(authentication, id) {
  return common_1.get(authentication, logisticsOptionsAuthorizedPath + id);
};

exports.getLogisticsOption = getLogisticsOption;

var putLogisticsOption = function putLogisticsOption(authentication, logisticsoption) {
  return common_1.put(authentication, logisticsOptionsAuthorizedPath + logisticsoption.id, logisticsoption);
};

exports.putLogisticsOption = putLogisticsOption;

var postLogisticsOption = function postLogisticsOption(authentication, logisticsoption) {
  return common_1.post(authentication, logisticsOptionsAuthorizedPath, logisticsoption);
};

exports.postLogisticsOption = postLogisticsOption;

var postLogisticsOptionPermission = function postLogisticsOptionPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, logisticsOptionsAuthorizedPath, id, permission);
};

exports.postLogisticsOptionPermission = postLogisticsOptionPermission;

var deleteLogisticsOptionPermission = function deleteLogisticsOptionPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, logisticsOptionsAuthorizedPath, id, permissionId);
};

exports.deleteLogisticsOptionPermission = deleteLogisticsOptionPermission;

var putLogisticsOptionAccessibility = function putLogisticsOptionAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, logisticsOptionsAuthorizedPath, id, accessibility);
};

exports.putLogisticsOptionAccessibility = putLogisticsOptionAccessibility;